const mainBody = {
	gradientColors: "#4484ce, #50ceeb, #1ad7c0, #5ca5e0",
	firstName: "Plebus",
	lastName: "Supremus",
	message: "A noob Python and TypeScript developer. ",
	icons: [
		{ image: "fa-github", url: "https://github.com/PlebusSupremus1234/" },
		{ image: "fa-discord", url: "https://discord.com/users/453103897012338688" },
		{ image: "fa-youtube", url: "http://youtube.com/Person47" }
	]
};

const about = {
	heading: "About Me",
	imageLink: require("../editable-stuff/pfp.png"),
	imageSize: 375,
	message: "My name is Plebus Supremus. I mainly code in Python, JavaScript, TypeScript and GoLang. In my free time, I like working on my personal projects and contributing to open source. "
};

const repos = {
	heading: "Favourite Projects",
	gitHubUsername: "PlebusSupremus1234",
	repos: ['LemonScript', 'Visualized-Sorting', 'TicTacGo', 'closest-match']
};

const contact = {
	heading: "Contact",
	message: "You can contact me either by email or on Discord.",
	email: "hl13851@gmail.com",
	discord: "Plebus Supremus#4334"
};

export { mainBody, about, repos, contact };